// src/components/AuthorCard.jsx
import React from "react";
import config from "../../../config";

export default function AuthorCard({ name, image }) {
  return (
    <div className="group relative overflow-hidden rounded-xl bg-white/60 backdrop-blur-lg shadow-md hover:shadow-xl transition-shadow duration-300">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent to-primary/30 opacity-0 group-hover:opacity-25 transition-opacity duration-500" />

      <div className="relative p-3 sm:p-4 md:p-5 flex flex-col items-center">
        {/* Profile image */}
        <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-4 border-white shadow-md transform group-hover:scale-105 transition-transform duration-500">
          <img
            src={
              image
                ? `${config.url}/authorImages/${image}`
                : "/images/default_author_img.png"
            }
            alt={name}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/default_author_img.png";
            }}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Author name */}
        <h3
          title={name} // optional: show full name on hover
          className="mt-2 text-sm sm:text-base md:text-lg font-medium text-gray-900 group-hover:text-primary transition-colors duration-300 text-center w-full truncate"
        >
          {name}
        </h3>
      </div>
    </div>
  );
}
